<template>
	<div id="app">
		<router-view />
	</div>
</template>
<script>
	import http from './util/request.js';
	export default {
		name: 'App',
		created() {
			//   window.localStorage
			if (window.localStorage.getItem('state')) {
				this.$store.replaceState(Object.assign({}, this.$store.state,
					JSON.parse(window.localStorage.getItem('state'))))
			}
			//   window.localStorage
			window.addEventListener('beforeunload', () => {
				window.localStorage.setItem('state', JSON.stringify(this.$store.state))
			})
		},
		methods: {}
	};
</script>

<style lang="scss">
	body {
		margin: 0;
		height: 100vh;
	}

	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		//   字体抗锯齿
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		height: 100%;
	}

	#nav {
		padding: 30px;

		a {
			font-weight: bold;
			color: #2c3e50;

			&.router-link-exact-active {
				color: #42b983;
			}
		}
	}
</style>